import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import {
  map,
  catchError,
  concatMap,
  exhaustMap,
  switchMap,
  mergeMap,
} from 'rxjs/operators';
import { of } from 'rxjs';
import * as StakeholderReferenceActions from './stakeholderreference.actions';
import { StakeholderReferenceService } from '../../services/stakeholderreference.service';

import { StakeholderReferenceDto } from '@cradua/data';

@Injectable()
export class StakeholderReferenceEffects {
  // loadStakeholderReference$ = createEffect(() =>
  // 	this.actions$.pipe(
  // 		ofType(StakeholderReferenceActions.loadStakeholderReference),
  // 		exhaustMap((_) =>
  // 			this.stakeholderreferenceService.getStakeholderReference("Club").pipe(
  // 				map((data) => {
  // 					console.log('data from database ', data);
  // 					return StakeholderReferenceActions.loadStakeholderReferenceSuccess({ stakeholderreference: data });
  // 				}),
  // 				catchError((error) => of(StakeholderReferenceActions.loadStakeholderReferenceFailure({ error })))
  // 			)
  // 		)
  // 	)
  // );

  transformedData(reftype: string, data: any[]): StakeholderReferenceDto[] {
    let transformData: StakeholderReferenceDto[];
    if (reftype === 'Language') {
      transformData = data.map((b) => {
        return {
          Type: 'Language',
          id: b.id,
          Name: b.LanguageName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'Club') {
      transformData = data.map((b) => {
        return {
          Type: 'Club',
          id: b.id,
          Name: b.ClubName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: b.CountryId,
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'ContactType') {
      transformData = data.map((b) => {
        return {
          Type: 'ContactType',
          id: b.id,
          Name: b.ContactTypeName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'League') {
      transformData = data.map((b) => {
        return {
          Type: 'League',
          id: b.id,
          Name: b.LeagueName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: b.CountryId,
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'Organization') {
      transformData = data.map((b) => {
        return {
          Type: 'Organization',
          id: b.id,
          Name: b.OrganizationName,
          Desc: '',
          Address: b.OrganizationAddress,
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: b.SectorId,
          StakeholderGroupId: '',
        };
      });
    }

    if (reftype === 'Property') {
      transformData = data.map((b) => {
        return {
          Type: 'Property',
          id: b.id,
          Name: b.PropertyName,
          Desc: '',
          Address: '',
          Location: b.PropertyLocation,
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'Sector') {
      transformData = data.map((b) => {
        return {
          Type: 'Sector',
          id: b.id,
          Name: b.SectorName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }

    if (reftype === 'SocialMediaType') {
      transformData = data.map((b) => {
        return {
          Type: 'SocialMediaType',
          id: b.id,
          Name: b.SocialMediaTypeName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }

    if (reftype === 'StakeholderGroup') {
      transformData = data.map((b) => {
        return {
          Type: 'StakeholderGroup',
          id: b.id,
          Name: b.StakeholderGroupName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }

    if (reftype === 'StakeholderSubGroup') {
      transformData = data.map((b) => {
        return {
          Type: 'StakeholderSubGroup',
          id: b.id,
          Name: b.StakeholderSubGroupName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: b.StakeholderGroupId,
        };
      });
    }

    if (reftype === 'AreaOfInterest') {
      transformData = data.map((b) => {
        return {
          Type: 'AreaOfInterest',
          id: b.id,
          Name: b.AreaOfInterestDesc,
          Desc: b.AreaOfInterestDesc,
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }

    if (reftype === 'PoliticalParty') {
      transformData = data.map((b) => {
        return {
          Type: 'PoliticalParty',
          id: b.id,
          Name: b.PoliticalPartyName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'Title') {
      transformData = data.map((b) => {
        return {
          Type: 'Title',
          id: b.id,
          Name: b.TitleName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }

    if (reftype === 'LineOfBusiness') {
      transformData = data.map((b) => {
        return {
          Type: 'LineOfBusiness',
          id: b.id,
          Name: b.LineOfBusinessName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'EngagementType') {
      transformData = data.map((b) => {
        return {
          Type: 'EngagementType',
          id: b.id,
          Name: b.EngagementTypeName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'EngagementCategory') {
      transformData = data.map((b) => {
        return {
          Type: 'EngagementCategory',
          id: b.id,
          Name: b.EngagementCategoryName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'EngagementDriver') {
      transformData = data.map((b) => {
        return {
          Type: 'EngagementDriver',
          id: b.id,
          Name: b.EngagementDriverName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'Company') {
      transformData = data.map((b) => {
        return {
          Type: 'Company',
          id: b.id,
          Name: b.CompanyName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'DocumentType') {
      transformData = data.map((b) => {
        return {
          Type: 'DocumentType',
          id: b.id,
          Name: b.DocumentTypeName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'DocumentSecurity') {
      transformData = data.map((b) => {
        return {
          Type: 'DocumentSecurity',
          id: b.id,
          Name: b.DocumentSecurityName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }
    if (reftype === 'DocumentPhysicalLocation') {
      transformData = data.map((b) => {
        return {
          Type: 'DocumentPhysicalLocation',
          id: b.id,
          Name: b.DocumentPhysicalLocationName,
          Desc: '',
          Address: '',
          Location: '',
          CountryId: '',
          SubscriberId: b.SubscriberId,
          SiteId: b.SiteId,
          SectorId: '',
          StakeholderGroupId: '',
        };
      });
    }

    return transformData;
  }

  loadByTypeStakeholderReference$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StakeholderReferenceActions.loadByTypeStakeholderReference),
      mergeMap((action) =>
        this.stakeholderreferenceService
          .getStakeholderReference(action.reftype)
          .pipe(
            map((data) => {
              console.log('Reaching Effect ', action.reftype);

              let mainData = this.transformedData(action.reftype, data);

              if (action.reftype === 'StakeholderGroup') {
                console.log('Data from ', mainData);
              }

              if (action.reftype === 'Club' || action.reftype === 'League') {
                if (action.countryId !== undefined) {
                  let countryId = action.countryId.toLowerCase();
                  mainData = mainData.filter((n) => n.CountryId === countryId);
                } else {
                  if (action.stakeholdergroupId !== undefined) {
                    mainData = mainData;
                  } else {
                    mainData = mainData.filter(
                      (n) => n.CountryId === action.countryId
                    );
                  }
                }

                console.log('Club Data ', mainData);
              }

              if (action.reftype === 'StakeholderSubGroup') {
                if (action.stakeholdergroupId !== undefined) {
                  mainData = mainData.filter(
                    (n) =>
                      n.StakeholderGroupId ===
                      action.stakeholdergroupId.toLowerCase()
                  );
                } else {
                  mainData = mainData.filter(
                    (n) => n.StakeholderGroupId === action.stakeholdergroupId
                  );

                  console.log(
                    'StakeholderGroup Id ',
                    action.reftype,
                    action.stakeholdergroupId,
                    mainData
                  );
                }
              }
              if (action.reftype === 'Organization') {
                if (action.stakeholdergroupId !== undefined) {
                  mainData = mainData.filter(
                    (n) =>
                      n.SectorId === action.stakeholdergroupId.toLowerCase()
                  );
                } else {
                  if (action.countryId !== undefined) {
                    mainData = mainData;
                  } else {
                    mainData = mainData.filter(
                      (n) => n.SectorId === action.stakeholdergroupId
                    );
                  }
                }
              }
              return StakeholderReferenceActions.loadByTypeStakeholderReferenceSuccess(
                { stakeholderreference: mainData }
              );
            }),
            catchError((error) =>
              of(
                StakeholderReferenceActions.loadByTypeStakeholderReferenceFailure(
                  { error }
                )
              )
            )
          )
      )
    )
  );

  loadByTypeStakeholderReferenceGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StakeholderReferenceActions.loadByTypeStakeholderReferenceGroup),
      exhaustMap((action) =>
        this.stakeholderreferenceService
          .getStakeholderReferenceGroup(action.reftype)
          .pipe(
            map((data) => {
              let mainData = this.transformedData(action.reftype, data);

              console.log('Data from Group ', mainData, action.reftype, data);

              // if(action.reftype === "StakeholderGroup")
              // {
              // 	console.log("Data from ", mainData);
              // }

              // if(action.reftype === "Club" || action.reftype === "League")
              // {

              // 	if(action.countryId !== undefined)
              // 	{

              // 		let countryId = action.countryId.toLowerCase();
              // 		mainData = mainData.filter(n => n.CountryId === countryId);

              // 	}else{
              // 		mainData = mainData.filter(n => n.CountryId === action.countryId);
              // 	}

              // }

              // if(action.reftype === "StakeholderSubGroup")
              // {
              // 	if(action.stakeholdergroupId !== undefined)
              // 	{
              // 	mainData = mainData.filter(n => n.StakeholderGroupId === action.stakeholdergroupId.toLowerCase())
              // 	}else{
              // 		mainData = mainData.filter(n => n.StakeholderGroupId === action.stakeholdergroupId);
              // 	}
              // }

              // if(action.reftype === "Organization")
              // {
              // 	if(action.stakeholdergroupId !== undefined)
              // 	{
              // 	mainData = mainData.filter(n => n.SectorId === action.stakeholdergroupId.toLowerCase())
              // 	}else{
              // 		mainData = mainData.filter(n => n.SectorId === action.stakeholdergroupId);
              // 	}
              // }
              return StakeholderReferenceActions.loadByTypeStakeholderReferenceGroupSuccess(
                { stakeholderreferencegroup: mainData }
              );
            }),
            catchError((error) =>
              of(
                StakeholderReferenceActions.loadByTypeStakeholderReferenceGroupFailure(
                  { error }
                )
              )
            )
          )
      )
    )
  );

  addStakeholderReference$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StakeholderReferenceActions.addStakeholderReference),
      concatMap(({ newStakeholderReference, reftype }) =>
        this.stakeholderreferenceService
          .createStakeholderReference(newStakeholderReference, reftype)
          .pipe(
            map((data) =>
              StakeholderReferenceActions.addStakeholderReferenceSuccess({
                newStakeholderReference: this.transformedData(reftype, data),
              })
            ),
            catchError((error) =>
              of(
                StakeholderReferenceActions.addStakeholderReferenceFailure({
                  error: error.error.message,
                })
              )
            )
          )
      )
    )
  );

  updateStakeholderReference$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StakeholderReferenceActions.updateStakeholderReference),
      // map((action) => {updateStakeholderReference: action.updateStakeholderReference, type: action.reftype}),
      concatMap(({ updateStakeholderReference, reftype }) =>
        this.stakeholderreferenceService
          .updateStakeholderReference(updateStakeholderReference, reftype)
          .pipe(
            map(() =>
              StakeholderReferenceActions.updateStakeholderReferenceSuccess({
                updateStakeholderReference: updateStakeholderReference,
              })
            ),
            catchError((error) =>
              of(
                StakeholderReferenceActions.updateStakeholderReferenceFailure({
                  error: error.message,
                })
              )
            )
          )
      )
    )
  );

  removeStakeholderReference$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StakeholderReferenceActions.removeStakeholderReference),
      // map((action) => action.ids),
      concatMap(({ ids, reftype }) =>
        this.stakeholderreferenceService
          .deleteStakeholderReference(ids, reftype)
          .pipe(
            map(() =>
              StakeholderReferenceActions.removeStakeholderReferenceSuccess({
                ids,
              })
            ),
            catchError((error) =>
              of(
                StakeholderReferenceActions.removeStakeholderReferenceFailure({
                  error: error.message,
                })
              )
            )
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private stakeholderreferenceService: StakeholderReferenceService
  ) {}
}
